import { LinearProgress, Paper } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import useAuth from "../../../../../hooks/auth";
import { useApiQuery } from "../../../../../hooks/use-api-query";
import { useInvisibleReCAPTCHA } from "../../../../../hooks/useInvisibleReCAPTCHA";
import { Alert } from "../../../../ui";
import InvisibleReCAPTCHA from "../../../../ui/InvisibleReCAPTCHA";
import { useQueryContext } from "../../context";
import MoreDataArea from "./areas/more";
import PessoasArea from "./areas/pessoas";
import PrecatorioArea from "./areas/precatorio";

const QueryDetails = () => {
  const { precatorioId, loadedPrecatorio } = useQueryContext();
  const [captchaToken, setCaptchaToken] = useState();

  const {
    isExecuting: isExecutingCaptcha,
    ref: captchaRef,
    executeAsync: executeCaptchaAsync,
  } = useInvisibleReCAPTCHA();

  const {
    user: { modules },
  } = useAuth();

  const { data, isStale, isLoading, isError } = useApiQuery(
    [modules.includes("rpv") ? "rpvs" : "precatorios", precatorioId],
    {
      extraParams: { captcha_token: captchaToken },
      useQueryOptions: {
        enabled: !!precatorioId && !!captchaToken,
        onSuccess: loadedPrecatorio,
      },
    }
  );

  const verifyCaptcha = async () => {
    const captchaToken = await executeCaptchaAsync();
    setCaptchaToken(captchaToken);
  };

  useEffect(() => {
    isStale && verifyCaptcha();
  }, [isStale]);

  return (
    <>
      <InvisibleReCAPTCHA ref={captchaRef} />

      {isError && (
        <Alert
          centerMessage
          severity="error"
          message="Ocorreu um erro ao processar sua busca. Se o erro persistir, entre em contato conosco."
        />
      )}

      {(isExecutingCaptcha || isLoading) && (
        <Paper>
          <div className="q-progress">
            <LinearProgress />
          </div>
        </Paper>
      )}

      {data && (
        <>
          <PrecatorioArea precatorio={data} />
          <PessoasArea precatorio={data} type="credor" />
          <PessoasArea precatorio={data} type="representante" />
          <MoreDataArea precatorio={data} />
        </>
      )}
    </>
  );
};

export default QueryDetails;
